__turbopack_context__.v({
  "description": "PreferencesDialog-module__q2TKzG__description",
  "dialog": "PreferencesDialog-module__q2TKzG__dialog",
  "group": "PreferencesDialog-module__q2TKzG__group",
  "option": "PreferencesDialog-module__q2TKzG__option",
  "options": "PreferencesDialog-module__q2TKzG__options",
  "tabs": "PreferencesDialog-module__q2TKzG__tabs",
});
